import { StatutDossierEnum } from "@resources/resources";

export class StatutDossierEnums {

  private static _enregistre: StatutDossierEnum = 'ENREGISTRE';
  private static _en_controle: StatutDossierEnum = 'EN_CONTROLE';
  private static _valide_partiel: StatutDossierEnum = 'VALIDE_PARTIEL';
  private static _valide_complet: StatutDossierEnum = 'VALIDE_COMPLET';
  private static _termine: StatutDossierEnum = 'TERMINE';

  static ENREGISTREE = new StatutDossierEnums(StatutDossierEnums._enregistre, 1);
  static EN_CONTROLE = new StatutDossierEnums(StatutDossierEnums._en_controle, 2);
  static VALIDE_PARTIEL = new StatutDossierEnums(StatutDossierEnums._valide_partiel, 3);
  static VALIDE_COMPLET = new StatutDossierEnums(StatutDossierEnums._valide_complet, 4);
  static TERMINE = new StatutDossierEnums(StatutDossierEnums._termine, 5);

  private static _values = [StatutDossierEnums.ENREGISTREE.value(),
  StatutDossierEnums.EN_CONTROLE.value(),
  StatutDossierEnums.VALIDE_PARTIEL.value(),
  StatutDossierEnums.VALIDE_COMPLET.value(),
  StatutDossierEnums.TERMINE.value()];

  private static _enumsValue = [
    StatutDossierEnums.ENREGISTREE,
    StatutDossierEnums.EN_CONTROLE,
    StatutDossierEnums.VALIDE_PARTIEL,
    StatutDossierEnums.VALIDE_COMPLET,
    StatutDossierEnums.TERMINE
  ];

  constructor(public str: StatutDossierEnum, public priorityOrder: number) {
  }

  public static getByCode(code: StatutDossierEnum) {
    for (let statut of this._enumsValue){
      if (statut.value() == code) {
        return statut;
      }
    }
    return null;
  }

  value(): StatutDossierEnum {
    return this.str;
  }

  order(): number {
    return this.priorityOrder;
  }

  static values(): Array<StatutDossierEnum> {
    return this._values;
  }
}


// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-serveur-resultats/digicerba-serveur-resultats-web/src/angular/cerba/src/app/common/enum/StatutDossier.enum.ts